module.exports = __webpack_public_path__ + "img/pump-undefined.a6869433.png";